import React from "react";

function GettingStartedContent() {
  return <p />;
}
export default GettingStartedContent;
